import { Injectable, inject } from '@angular/core';

import { CookieService } from '@frontend/vanilla/core';

import { ChannelType } from '../config/appConstants';
import { DataService } from './data.service';
import { QuickDepositMessageService } from './quick-deposit-message.service';

@Injectable({
    providedIn: 'root',
})
export class EventService {
    private dataService = inject(DataService);
    private cookieService = inject(CookieService);
    private quickDepositMessageService = inject(QuickDepositMessageService);

    private sessionInfo: any;
    private isNativeApp: boolean;
    constructor() {
        this.sessionInfo = this.dataService?.sessionInfo;
        this.isNativeApp = !![ChannelType.AN, ChannelType.IN].includes(this.sessionInfo?.channelId);
    }

    raiseCloseEvent() {
        const clientScheme = this.cookieService.get('clientScheme');
        if (clientScheme) {
            const appUrl = `${clientScheme}://?event=closeSfSafariWindow`;
            document.location.href = appUrl;
        } else {
            if (this.isNativeApp) {
                const frame = document.createElement('IFRAME');
                frame.setAttribute('src', 'bwinex://?event=qd_close');
                frame.setAttribute('border', '0');
                frame.setAttribute('width', '0');
                frame.setAttribute('height', '0');
                frame.setAttribute('frameborder', '0');
                document.body.appendChild(frame);
            }
            this.quickDepositMessageService.sendOutput('action=close');
        }
    }

    raiseDepositEvent(url: any) {
        if (this.isNativeApp) {
            const frame = document.createElement('IFRAME');
            frame.setAttribute('src', url);
            frame.setAttribute('border', '0');
            frame.setAttribute('width', '0');
            frame.setAttribute('height', '0');
            frame.setAttribute('frameborder', '0');
            document.body.appendChild(frame);
        }
    }

    raiseUpdateBalanceEvent() {
        this.quickDepositMessageService.sendOutput('action=updateBalance');
    }
}
